import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';

//Servicios
import { DefaultService } from '../../../services/default.service';

@Component({
  selector: 'app-proyecto',
  templateUrl: './proyecto.component.html',
  styleUrls: ['./proyecto.component.css'],
  providers: [
    DefaultService
  ]
})
export class ProyectoComponent implements OnInit {

  public user:any = {};
  public login:boolean = false;
  
  constructor(
    private http: HttpClient,
    public _defaultService: DefaultService,
  ){ }

  ngOnInit() {
    this.logeado();
  }

  logeado(){
    this._defaultService.isLogged().subscribe(result => {
      if(result != null && result.emailVerified == true){
        this._defaultService.Data("users", result.uid).subscribe(user => {
          this.user = user;
          this.login = true;
        });
      } 
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Practicos/proyecto/proyecto.component.ts